export default [
  {
  	path: '/weixiaodianxin',
  	name: 'weixiaodianxin',
  	component: () => import('@/views/weixiaodian')
  }
]



// WEBPACK FOOTER //
// ./src/router/weixiaodian.js